import {createReducer} from '@reduxjs/toolkit';
import {
    getContractsDetailsFailure,
    getContractsDetailsRequest,
    getContractsDetailsSuccess,
    getIntegrationContractsFailure,
    getIntegrationContractsRequest,
    getIntegrationContractsSuccess,
    updateIntegrationContractFailure,
    updateIntegrationContractRequest, updateIntegrationContractSuccess,
    updatePayPerCallContractFailure,
    updatePayPerCallContractRequest, updatePayPerCallContractSuccess,
    updateSubscriptionContractFailure,
    updateSubscriptionContractRequest, updateSubscriptionContractSuccess,
} from 'src/openapi/admin/apis/ContractControllerApi';
import {
    updateCreditBalanceFailure,
    updateCreditBalanceRequest,
    updateCreditBalanceSuccess,
} from 'src/openapi/admin/apis/CreditControllerApi';

import {OBSOLETE_REQUEST_ERROR} from '@pb/middleware-api';

import {clearContracts} from '../../../contracts/services/actions';
import {clearError} from '../actions';

import type {ContractsListDto} from '../../../contracts/typedef';
import type {Error} from 'src/openapi/admin/models/Error';


export type State = {
    data: Record<number, ContractsListDto | null>,
    error: Error | null,
    pricingBusy: boolean,
    requiredRefresh: boolean,
};

const defaultState: State = {
    data: {},
    error: null,
    pricingBusy: false,
    requiredRefresh: false,
};

export const contractsData = createReducer(defaultState, builder => builder
    .addCase(getIntegrationContractsRequest, state => {
        state.pricingBusy = true;
    })
    .addCase(getContractsDetailsRequest, state => {
        state.pricingBusy = true;
    })
    .addCase(updateSubscriptionContractRequest, state => {
        state.pricingBusy = true;
    })
    .addCase(updatePayPerCallContractRequest, state => {
        state.pricingBusy = true;
    })
    .addCase(updateIntegrationContractRequest, state => {
        state.pricingBusy = true;
    })
    .addCase(updateCreditBalanceRequest, state => {
        state.pricingBusy = true;
    })
    .addCase(getContractsDetailsSuccess, (state, action) => {
        state.pricingBusy = false;
        state.requiredRefresh = false;
        state.data = {
            ...state.data,
            [action.payload.meta.accountId]: (action.payload.data as ContractsListDto),
        };
    })
    .addCase(getIntegrationContractsSuccess, (state, action) => {
        state.pricingBusy = false;
        state.requiredRefresh = false;
        state.data = {
            ...state.data,
            [action.payload.meta.accountId]: action.payload.data,
        };
    })
    .addCase(updateCreditBalanceSuccess, state => {
        state.requiredRefresh = true;
    })
    .addCase(updateSubscriptionContractSuccess, state => {
        state.requiredRefresh = true;
    })
    .addCase(updatePayPerCallContractSuccess, state => {
        state.requiredRefresh = true;
    })
    .addCase(updateIntegrationContractSuccess, state => {
        state.requiredRefresh = true;
    })
    .addCase(getIntegrationContractsFailure, (state, action) => {
        state.error = action.payload.data?.error !== OBSOLETE_REQUEST_ERROR.reason ? action.payload.data : null;
        state.pricingBusy = false;
        state.requiredRefresh = false;
    })
    .addCase(getContractsDetailsFailure, (state, action) => {
        state.error = action.payload.data?.error !== OBSOLETE_REQUEST_ERROR.reason ? action.payload.data : null;
        state.pricingBusy = false;
        state.requiredRefresh = false;
    })
    .addCase(updateSubscriptionContractFailure, (state, action) => {
        state.error = action.payload.data?.error !== OBSOLETE_REQUEST_ERROR.reason ? action.payload.data : null;
        state.pricingBusy = false;
    })
    .addCase(updatePayPerCallContractFailure, (state, action) => {
        state.error = action.payload.data?.error !== OBSOLETE_REQUEST_ERROR.reason ? action.payload.data : null;
        state.pricingBusy = false;
    })
    .addCase(updateIntegrationContractFailure, (state, action) => {
        state.error = action.payload.data?.error !== OBSOLETE_REQUEST_ERROR.reason ? action.payload.data : null;
        state.pricingBusy = false;
    })
    .addCase(updateCreditBalanceFailure, (state, action) => {
        state.error = action.payload.data?.error !== OBSOLETE_REQUEST_ERROR.reason ? action.payload.data : null;
        state.pricingBusy = false;
    })
    .addCase(clearError, state => {
        state.error = null;
    })
    .addCase(clearContracts, state => {
        state.data = {};
    }),
);
